import CarrierRecordView from './CarrierRecordView';

export default CarrierRecordView;
